import React from 'react';

import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
import LinkList from '../components/linklist/LinkList';

import './helpandguides.styl';
import 'bootstrap/dist/css/bootstrap.css';
import '../../ext/font-awesome-4.7.0/css/font-awesome.css';

import { PageText, Categories } from '../input-text/en/helpandguides_page';

class Help extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <i className="fa fa-question-circle-o fa-5x help-icon" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } component={ <LinkList links={ Categories._1.links } /> } />
        <CategoryContainer cols='1' category={ Categories._3 } component={ <LinkList links={ Categories._3.links } /> } />
        <CategoryContainer cols='1' category={ Categories._2 } component={ <LinkList links={ Categories._2.links } /> } />
        <CategoryContainer cols='1' category={ Categories._5 } component={ <LinkList links={ Categories._5.links } /> } />
      </div>
    );
  }
};

export default Help;



// WEBPACK FOOTER //
// ./src/routes/HelpAndGuides.js